import React from 'react';
import PropTypes from 'prop-types';
import ResourceDownload from '../../../02_molecules/ResourceDownload';
import {
  behaviorSettingsProps,
  generateClassNameByBehaviorSettings,
} from '../../../../utils/behaviorSettings';

import styles from './index.module.scss';

const BBResourcesDownload = ({ title = '', resources, behaviorSettings = null, uuid = null }) => (
  <div
    className={`bb ${styles['bb-resources-download']} ${generateClassNameByBehaviorSettings(
      behaviorSettings,
    )}`}
    id={uuid}
  >
    <div className="container">
      {title && <h2>{title}</h2>}

      <div className={styles['resources']}>
        {resources.map((resource, i) => (
          <ResourceDownload {...resource} key={`resource-download-${i}`} />
        ))}
      </div>
    </div>
  </div>
);

BBResourcesDownload.propTypes = {
  title: PropTypes.string,
  resources: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      downloadURL: PropTypes.string.isRequired,
      info: PropTypes.string,
      description: PropTypes.string,
      actionIcon: PropTypes.oneOf(['download', 'tab']),
      format: PropTypes.oneOf([
        'PDF',
        'DOC',
        'DOCX',
        'XLSX',
        'XLS',
        'PPTX',
        'PPT',
        'ZIP',
        'AVI',
        'MP4',
        'MP3',
        'TXT',
        'JPEG',
        'PNG',
        'GIF',
        'WEBP',
        'undefined',
      ]),
    }),
  ).isRequired,
  behaviorSettings: behaviorSettingsProps,
  uuid: PropTypes.string,
};

export default BBResourcesDownload;
